export default __webpack_public_path__ + "static/media/logonova2.7f8e6490.png";